import { render, staticRenderFns } from "./RowPricingItem.vue?vue&type=template&id=3ba7bbfa&"
import script from "./RowPricingItem.vue?vue&type=script&lang=js&"
export * from "./RowPricingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports